<template>
    <div
        v-show="show"
        :class="{
            'callout': true,
            'callout-success': type === 'success',
            'callout-warning': type === 'warning',
            'callout-info': type === 'info',
            'callout-danger': type === undefined || type ==='danger',
            'callout-visible': show,
            'callout-hidden': !show,
        }"
        role="alert"
    >
        <h4 v-if="message">
            {{ message }}
        </h4>
        <p
            v-for="error in messages"
            :key="error"
        >
            {{ error }}
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: null,
            },
            message: {
                type: String,
                default: null,
            },
            messages: {
                type: Array,
                default: null,
            },
        },
        computed: {
            show() {
                return this.messages && this.messages.length;
            },
        },
    };
</script>
